import { observable, action, makeAutoObservable, runInAction } from "mobx";
import { message, notification } from "antd";
import { persist } from 'mobx-persist';
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";

class ReportStore {

    @observable loading = false;
    @observable isSuccess = false;

    @observable perPage = 10;
    @observable hasMore = false;
    @observable page = 1;

    @observable audittrails = [];

    constructor() {
        makeAutoObservable(this);
    }

    @action
    fetchAuditTrails = async () => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/reports/get_all_audittrails.php?perPage=${this.perPage}&page=${this.page}&sortBy=ASC&orderBy=CreatedAt`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            console.log()
            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.audittrails = response.data.data;
                        if (this.audittrails && this.audittrails.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Audit Trails Error',
                    description: error.response.data.message
                });
                message.error('Fetching Audit Trails Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
        
    }
}

export default ReportStore;
